import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetDashboardVisitMutation = createMutationHook(ShopsApiClient.setDashboardVisit, {
  mutationKey: ['setDashboardVisit'],
})
